var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.72223C11.0019 6.45549 10.8306 7.17883 10.5 7.83334C10.108 8.61764 9.5054 9.27732 8.75968 9.73849C8.01396 10.1997 7.15457 10.4441 6.27777 10.4444C5.54451 10.4464 4.82117 10.275 4.16666 9.94445L1 11L2.05555 7.83334C1.72496 7.17883 1.55364 6.45549 1.55555 5.72223C1.55589 4.84543 1.80034 3.98604 2.26151 3.24032C2.72268 2.4946 3.38236 1.892 4.16666 1.50002C4.82117 1.16942 5.54451 0.998104 6.27777 1.00002H6.55555C7.71352 1.0639 8.80723 1.55266 9.62729 2.37271C10.4473 3.19277 10.9361 4.28648 11 5.44445V5.72223Z",
    stroke: "url(#paint0_radial_1365_15343)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1365_15343",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.65626 11.7702) rotate(-90) scale(9.91074 9.21777)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaComment);
export default __webpack_public_path__ + "static/media/instaComment.dccd7c8a.svg";
export { ForwardRef as ReactComponent };